module.exports = __webpack_public_path__ + "media/images/talent/bg-mv-65c047c22ef0d9f0c6e4ef9126d161b3.png";